import { wrapNavigatorScreen } from '@euler/functions/wrapNavigatorScreen';

export const FreeDrawingWithSkia = wrapNavigatorScreen(() => null);
